import React, { useCallback, useState } from "react";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";

import LogoIcon from "../../assets/images/logo-icon.png";
import { authConstants } from "../../constants";
import { adminPasswordSchema } from "../../schemas";
import BaseModal from "../../shared/components/modals/BaseModal";
import MainSpinner from "../../shared/components/spinner/MainSpinner";
import RoundedButton from "../../shared/components/buttons/RoundedButton";
import { adminActions } from "../../redux/actions";

const AdminPasswordModal = (props) => {
  const { show, onClose, updateAdminPassword, spinnerActions, user } = props;
  const [showPassword, setShowPassword] = useState({
    currentPassword: false,
    password: false,
    confirmPassword: false,
  });

  const handleShowPassword = (field) => {
    setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  // Initialize form with yupResolver for validation
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(adminPasswordSchema),
    mode: "onChange",
  });

  // Handle form submission
  const onSubmit = (data) => {
    updateAdminPassword({ ...data, id: user.userId }, () => closeModal());
  };

  const spinner = useCallback(
    (type) => spinnerActions.findIndex((s) => s === type),
    // eslint-disable-next-line
    [spinnerActions]
  );

  const closeModal = () => {
    onClose();
    reset();
  };

  return (
    <BaseModal
      centered
      show={show}
      onClose={closeModal}
      className="subadmin-modal"
      size="xs"
    >
      {spinner(authConstants.CHANGE_PASSWORD) > -1 && (
        <MainSpinner className="admin-spinner" />
      )}
      <div className="forgot-form">
        <div className="d-flex justify-content-center mb-5">
          <img src={LogoIcon} alt="Bayview Shores" height={49} />
          <p className="login-brand-logo">Bayview Shores</p>
        </div>
        <div className="form-heading">Change Password</div>
        <div className="forgot-desc reset-desc">
          Set your new password to login into your account!
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="position-relative">
            <input
              className={`auth-form-input  mt-4 ${
                errors.currentPassword ? "is-invalid" : ""
              }`}
              placeholder="Enter old password"
              type={showPassword.currentPassword ? "text" : "password"}
              {...register("currentPassword")}
            />
            {showPassword.currentPassword ? (
              <IoIosEye
                className="position-absolute reset-field-icon reset-field-icon-password pointer"
                onClick={() => handleShowPassword("currentPassword")}
              />
            ) : (
              <IoIosEyeOff
                className="position-absolute reset-field-icon reset-field-icon-password pointer"
                onClick={() => handleShowPassword("currentPassword")}
              />
            )}
          </div>
          {errors.currentPassword && (
            <div className="error">{errors.currentPassword.message}</div>
          )}
          <div className="position-relative">
            <input
              className={`auth-form-input  mt-4 ${
                errors.password ? "is-invalid" : ""
              }`}
              placeholder="Enter new password"
              type={showPassword.password ? "text" : "password"}
              {...register("password")}
            />
            {showPassword.password ? (
              <IoIosEye
                className="position-absolute reset-field-icon reset-field-icon-password pointer"
                onClick={() => handleShowPassword("password")}
              />
            ) : (
              <IoIosEyeOff
                className="position-absolute reset-field-icon reset-field-icon-password pointer"
                onClick={() => handleShowPassword("password")}
              />
            )}
          </div>
          {errors.password && (
            <div className="error">{errors.password.message}</div>
          )}
          <div className="position-relative">
            <input
              className={`auth-form-input  mt-4 ${
                errors.confirmPassword ? "is-invalid" : ""
              }`}
              placeholder="Confirm password"
              type={showPassword.confirmPassword ? "text" : "password"}
              {...register("confirmPassword")}
            />
            {showPassword.confirmPassword ? (
              <IoIosEye
                className="position-absolute reset-field-icon reset-field-icon-password pointer"
                onClick={() => handleShowPassword("confirmPassword")}
              />
            ) : (
              <IoIosEyeOff
                className="position-absolute reset-field-icon reset-field-icon-password pointer"
                onClick={() => handleShowPassword("confirmPassword")}
              />
            )}
          </div>
          {errors.confirmPassword && (
            <div className="error">{errors.confirmPassword.message}</div>
          )}
          <RoundedButton
            cotainerClass="d-flex justify-content-center reset-form-bottom-button"
            className="auth-button mx-auto bg-light border-light w-65 py-2"
            type="submit"
            disabled={spinner(authConstants.CHANGE_PASSWORD) > -1}
          >
            {spinner(authConstants.CHANGE_PASSWORD) > -1
              ? "Submitting..."
              : "Confirm"}
          </RoundedButton>
        </form>
      </div>
    </BaseModal>
  );
};

const mapStateToProps = (state) => ({
  spinnerActions: state.systemReducer.spinnerActions,
  user: state.authReducer.user,
});

const mapDispatchToProps = (dispatch) => ({
  updateAdminPassword: (data, func) =>
    dispatch(adminActions.updateAdminPassword(data, func)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminPasswordModal);
